import queryString from 'query-string';
import {ReactComponent as SuccessIcon} from 'assets/images/success.svg';
import {ReactComponent as Danger} from 'assets/images/danger.svg';
import {getError} from 'utils/helpers';
import {CheckoutLayout} from 'components/Checkouts/CheckoutSC';
import CheckoutWrapper from 'components/Checkouts/Checkout/common/CheckoutWrapper';
import BigSpinner from 'utils/Spinner/BigSpinner';
import {useLASGReceipt} from './useLASGQuery';
import LASGHeader from './LASGHeader';
import LASGReceiptCard from './LASGReceiptCard';

const LASGReceipt = ({location}) => {
    const {reference} = queryString.parse(location?.search);
    const {isLoading, isError, error, receipt, hasReceipt, timedOut} = useLASGReceipt(reference);

    const isPolling = isLoading || (!hasReceipt && !timedOut && !isError);

    const renderContent = () => {
        if (isPolling)
            return (
                <div className="text-center py-5 px-3">
                    <BigSpinner />
                    <p className="fw-semibold mt-4 mb-1">Verifying your payment with LASG...</p>
                    <p className="text--gray small">
                        This may take a moment. Please do not close this page.
                    </p>
                </div>
            );

        if (hasReceipt)
            return (
                <>
                    <div className="text-center py-3">
                        <SuccessIcon />
                        <h3 className="fw-bold mt-3">Payment Confirmed</h3>
                        <p className="text--gray">Your payment has been confirmed by LASG.</p>
                    </div>
                    <LASGReceiptCard receipt={receipt} />
                </>
            );

        const errMsg = timedOut
            ? 'Receipt is taking longer than expected. Please check back later.'
            : getError(error?.response?.data ?? error);

        return (
            <div className="text-center py-4">
                <Danger width={30} height={30} />
                <h3 className="fw-bold mt-4">Receipt Unavailable</h3>
                <p className="text--gray">{errMsg}</p>
            </div>
        );
    };

    return (
        <CheckoutLayout className="checkout">
            <div className="checkout__container">
                <div className="checkout__main py-4">
                    <CheckoutWrapper isFrame={false} sendEvent={() => {}}>
                        <LASGHeader />
                        <div className="p-4">{renderContent()}</div>
                    </CheckoutWrapper>
                </div>
            </div>
        </CheckoutLayout>
    );
};

export default LASGReceipt;
